// Aviation lesson triggers (M54.1, ARCH §29.4). PURE (ENG-1).
//
// The host (`boot.ts`) owns the actual firing (`fireEduTrigger`) — these are the
// three small decisions behind it, factored out so they have one definition
// instead of living only inline in a large host file: a landing is the ground
// edge minus a crash (E-28's other outcome), a runway surface is a fixed set of
// block names (the aeroway pavement/centerline paint, `atlas/aeroway.ts`), and
// the autopilot hold streak is "how many consecutive ticks has altitude error
// stayed at/under the tolerance" — reset the instant it doesn't.
import type { Aircraft } from './aircraft';

/** A gentle touchdown this tick: airborne last tick, on the ground now, and NOT
 *  the crash outcome (E-28's other resolution of the same ground contact). */
export function isLanding(wasOnGround: boolean, a: Aircraft): boolean {
  return !wasOnGround && a.onGround && !a.crashed;
}

/** The runway pavement/centerline-paint block names (`atlas/aeroway.ts` AVI-1) —
 *  "landed ON the runway" vs. landed somewhere else nearby. */
const RUNWAY_SURFACE = new Set(['light_gray_concrete', 'white_concrete']);
export function isRunwaySurface(blockName: string | undefined): boolean {
  return blockName !== undefined && RUNWAY_SURFACE.has(blockName);
}

/** Next value of the autopilot-hold streak: `prev+1` if this tick's altitude
 *  error is at/under `maxError`, else reset to 0. */
export function holdStreak(prevTicks: number, error: number, maxError: number): number {
  return error <= maxError ? prevTicks + 1 : 0;
}
